import { ErrorCode, ErrorName, CustomError } from "./types";

export class NotFoundError extends Error implements CustomError {
  public message: string;
  public name: string;
  public statusCode: number;
  constructor(message = "") {
    super(message);
    this.message = message;
    this.statusCode = ErrorCode.NotFound;
    this.name = ErrorName.NotFound;
  }
}
